import { render, staticRenderFns } from "./Edit-role.vue?vue&type=template&id=08be48e3&scoped=true"
import script from "./Edit-role.vue?vue&type=script&lang=js"
export * from "./Edit-role.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08be48e3",
  null
  
)

export default component.exports